import React from 'react';

// third-party 
import { DiscussionEmbed } from 'disqus-react';
import PropTypes from 'prop-types';

// Reading environment variable start
const DISQUS_SHORT_NAME = process.env.REACT_APP_DISQUS_SHORT_NAME;


const Comment = ( { url, id, title } ) => {
    const disqusShortname = DISQUS_SHORT_NAME; // Set Disqus short name 
    const disqusConfig = {
        url: url, // URL of the page 
        identifier: `${id}`, // Unique identifier for the thread
        title: title // Title of the thread
    };
    return (
        <DiscussionEmbed shortname={ disqusShortname } config={ disqusConfig } />
    )
}

Comment.propTypes = {
    url: PropTypes.string, // URL prop type
    id: PropTypes.number, // ID prop type
    title: PropTypes.string // Title prop type
};

export default Comment;